import { useQuery } from "@tanstack/react-query";
import { OWGameResponse } from "@devour/client";
import getConfig from "../../utils/getConfig";

async function fetchGameBySlug(slug: string): Promise<OWGameResponse | null> {
    if (!slug) return null;

    const response = await fetch(`${getConfig().basePath}/overwolf/games/${slug}`);

    if (!response.ok) {
        if (response.status === 404) {
            return null; // Game not found
        }
        throw new Error(`Failed to fetch game: ${response.statusText}`);
    }

    const game: OWGameResponse = await response.json();
    return game;
}

export const useGameBySlug = (slug?: string) => {
    const query = useQuery<OWGameResponse | null>({
        queryKey: ["game-by-slug", slug],
        queryFn: () => fetchGameBySlug(slug!),
        enabled: !!slug,
        staleTime: 5 * 60 * 1000, // 5 minutes
        gcTime: 10 * 60 * 1000, // 10 minutes in cache
    });

    return {
        game: query.data,
        isLoading: query.isLoading,
        error: query.error ? "Failed to load game" : null,
        isError: query.isError,
    };
};